import React, {useState} from 'react';

import styled from 'styled-components';

import {Pagination} from 'components/ui-kit/Pagination';

import {AuditReference} from './Reference';
import {CountRow, CountsTable} from './styled';

const PAGE_SIZE = 4;

const CodeRow = styled(CountRow)`
    grid-template-columns: minmax(0, 1fr);

    > :last-child {
        text-align: left;
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
`;

const PaginationContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
`;

export const AuditMarkingCodesTable = ({codes, label}: {codes: string[]; label: string}) => {
    const [page, setPage] = useState(0);
    if (!codes.length) return null;

    const lastPage = Math.ceil(codes.length / PAGE_SIZE) - 1;
    const currentPage = Math.min(page, lastPage);
    return (
        <>
            <CountsTable role="table" aria-label={label}>
                <CodeRow header role="row">
                    <span role="columnheader">{label}</span>
                </CodeRow>
                {codes
                    .slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE)
                    .map((code, index) => (
                        <CodeRow key={`${currentPage}-${index}`} role="row">
                            <span role="cell">
                                <AuditReference field="markingCode" value={code} />
                            </span>
                        </CodeRow>
                    ))}
            </CountsTable>
            {lastPage > 0 && (
                <PaginationContainer>
                    <Pagination
                        currentPageIndex={currentPage}
                        lastPageIndex={lastPage}
                        onPageIndexChange={setPage}
                    />
                </PaginationContainer>
            )}
        </>
    );
};
